import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { TVAuthProvider } from './TVContext';
import TVPair from './TVPair';
import TVBrowse from './TVBrowse';
import TVDetail from './TVDetail';
import TVPlayer from './TVPlayer';
import TVSignIn from './TVSignIn';
import TVSignUp from './TVSignUp';
import './tv.css';

/**
 * Root of the TV application (served at /tv/*).
 * Layout is landscape-first, D-pad focus driven, and decoupled from the web navbar.
 */
const TVApp = () => {
  return (
    <TVAuthProvider>
      <Routes>
        <Route index element={<TVPair />} />
        <Route path="signin" element={<TVSignIn />} />
        <Route path="signup" element={<TVSignUp />} />
        <Route path="browse" element={<TVBrowse />} />
        <Route path="content/:id" element={<TVDetail />} />
        <Route path="watch/:id" element={<TVPlayer />} />
        <Route path="*" element={<Navigate to="/tv" replace />} />
      </Routes>
    </TVAuthProvider>
  );
};

export default TVApp;
